import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import { fetchFollowsForCurrentMember } from '../../../services/store/modules/follows';
import {
  fetchLoggedInMembersPositions,
  getSharedSignalsWithCurrentMember,
} from '../../../services/store/modules/signal';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import FindFriendsToFollowPage from './FindFriendsToFollowPage/FindFriendsToFollowPage';
import FriendsPage from './FriendsPage/FriendsPage';
import SignalAddSharedUsersPage from './SignalAddSharedUsersPage/SignalAddSharedUsersPage';
import SignalHomePage from './SignalHomePage/SignalHomePage';
import SignalMarkerSheet from './SignalMarkerSheet/SignalMarkerSheet';

const SignalFeature: FC = () => {
  const { path } = useRouteMatch();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLoggedInMembersPositions());
    dispatch(getSharedSignalsWithCurrentMember());
    dispatch(fetchFollowsForCurrentMember());
  }, [dispatch]);

  return (
    <Switch>
      <Route path="/maps/signal/following" exact>
        <Redirect to="/maps/signal/friends-sheet" />
      </Route>
      <Route path="/maps/signal/friends-sheet" exact>
        <FriendsPage />
      </Route>
      <Route path="/maps/signal" exact>
        <Redirect to={`${path}/you`} />
      </Route>
      <Route path={`${path}/:pagename(you|following)`} exact>
        <SignalHomePage />
      </Route>
      <Route path={`${path}/find-friends-to-follow`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <FindFriendsToFollowPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/search`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <SignalAddSharedUsersPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/:id`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <SignalMarkerSheet />
        </AuthCheck>
      </Route>
    </Switch>
  );
};

export default SignalFeature;
